import { useCallback } from 'react';

import { sendStaffEvent } from 'src/observability/sendStaffEvent';
import type { StaffEventBody, LegacyStaffEventBody } from 'src/observability/staffEventTypes';

export const useObservability = (enabled = false) => {
  return useCallback(
    (event: LegacyStaffEventBody | StaffEventBody) => {
      try {
        if (!enabled) {
          console.debug('Observability is disabled, not sending event:', event);
          return;
        }

        sendStaffEvent(event);
      } catch (error) {
        console.error('Error sending staff observability event:', error);
      }
    },
    [enabled],
  );
};
